import { usePrevious } from './usePrevious';

export function useWhyUpdated(label: any, e: Record<string, any>) {
  const previousData = usePrevious(e);

  const diffs: any[] = [];
  Object.entries(e).forEach(([key, value]) => {
    if (!Object.is(value, previousData.current?.[key])) {
      diffs.push({ key, value, previous: previousData.current?.[key] });
    }
  });

  if (diffs.length) {
    console.log(label, diffs);
  }
}
